import React, { useContext,useState } from 'react';

import { connect } from "react-redux";
import * as actions from "../../../store/actions";
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useStyles } from "./styles";
import { generalStyles } from "../general/general";
import { ropay } from "../../../assets/images/img/index";
import { Box, AppBar, Toolbar, Container, Badge } from '@material-ui/core';
import Navbar from './Navbar.js';
import "../scss/header.scss";
import { getUserDataFromLocalStorage } from "../../../services/utils";
import AddCart from '../../frontend/cart';
import LoginModal from './LoginModal.js';
import ProfileMenu from './profileMenu.js';
import { ThemeContext } from '../../../ThemeContext.js';
import { useTranslation } from 'react-i18next';
import Language from './language.js';
import { useCart } from '../layout/cartContext';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import { logout, voucher, userPen, foodOrder, helpCenter, LogoutIcon } from '../../../assets/images/img';
import { cartIcon } from '../../../assets/images/newImages';

// Custom hooks
import { useAuth } from './hooks/useAuth';
import { useHeaderCart } from './hooks/useHeaderCart';
import { useScrollBehavior } from './hooks/useScrollBehavior';
import { useRestaurantHeader } from './hooks/useRestaurantHeader';

function Header(props) {
  const { loggedInSuccess, restaurantSuccess, updateOrderItemSuccess, currentLanguage, cartItemsList } = props;
  const history = useHistory();
  const { t } = useTranslation();
  const { cartItems, removeItemFromCart, isDivVisible } = useCart();
  
  const isMobile = useMediaQuery('(max-width:960px)');
  const userDetail = getUserDataFromLocalStorage();
  const classes = useStyles();
  const generalClasses = generalStyles();
  const location = useLocation().pathname;
  const { themeValue } = useContext(ThemeContext);
  const [keywords, setKeywords] = React.useState([]);
  // const [itemQuantity,setItemQuantity] = React.useState(0);
  // console.log("itemQuantity", itemQuantity);
  // const [restaurant, setRestaurant] = useState(null);
  const [cartItemDeleted, setCartItemDeleted] = useState(false);
  const [cartItemDeletedIndex, setCartItemDeletedIndex] = useState(null);
  const [innerCartItems, setInnerCartItems] = useState([]);
  // console.log("innerCartItems in header",innerCartItems);
  // const [totalPrice, setTotalPrice] = useState(0);
  // const [totalQuantity, setTotalQuantity] = useState(0);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  

  // Custom hooks for cleaner state management (consolidates 7 useEffect hooks)
  const {
    isLoggedIn,
    openModal,
    openModalProfile,
    setOpenModalProfile,
    handleOpen,
    handleClose,
    handleOpenProfile,
    handleCloseProfile,
    handleLoginSuccess,
    handleLogout
  } = useAuth();

  const { restaurant } = useRestaurantHeader({ restaurantSuccess });

  const {
    itemQuantity,
    openModalCart,
    totalPrice,
    totalQuantity,
    setOpenModalCart,
    setTotalPrice,
    setTotalQuantity,
    handleOpenCart,
    handleCloseCart
  } = useHeaderCart({
    cartItemsList,
    currentLanguage,
    cartItems,
    restaurant,
    loggedInSuccess,
    removeItemFromCart,
    updateOrderItem: props.updateOrderItem,
    updateOrderItemSuccess,
    getCartItems: props.getCartItems
  });

  const { isScrollingUp } = useScrollBehavior();

  // Menu configuration
  const loggedInMenuItems = [
    { icon: foodOrder, title: t('Order & Reordering'), url: '' },
    { icon: userPen, title: t('profile'), url: '' },
    { icon: voucher, title: t('vouchers'), url: '' },
    { icon: helpCenter, title: t('helpCentre'), url: '' },
    { icon: LogoutIcon, title: t('logout'), url: '/logout' },
  ];

  const loggedOutMenuItems = [
    { icon: foodOrder, title: t('orderReordering'), url: '' },
    { icon: userPen, title: t('profile'), url: '' },
    { icon: voucher, title: t('vouchers'), url: '' },
    { icon: helpCenter, title: t('helpCentre'), url: '' },
  ];

  const menuItems = isLoggedIn ? loggedInMenuItems : loggedOutMenuItems;

  const goToPage = (item) => {
    if (item.url === '/logout') {
      handleLogout();
    } else {
      history.push({ pathname: './' });
    }
  };
  return (
    <div className='wrapper-center'>
      <div className={generalClasses.root} data-theme={themeValue}>
        {location && (
          <>
            <AppBar position="relative" className="navbar-white navbar-wahite-fixed">
              <Container maxWidth={false} className='header-container' fixed>
                {/* Restaurant Banner Image */}
                <div className={`restaurant-image-div-1 header-height-max ${isScrollingUp ? 'header--visible' : 'header--hidden'}`}>
                  <img src={restaurant?.branches[0]?.cover_image} alt="Restaurant Banner" className='restaurant-image-banner' />
                </div>

                {/* Restaurant Logo */}
                <div className='profile-header'>
                  <div className='riyaPay-logo-main riyaPay-logo riyaPay-logo-1'>
                    <img src={restaurant?.logo} alt="Restaurant Logo" />
                  </div>
                </div>

                <Toolbar className="header-bar">
                  <div className='navbar-inner'>
                    <div className='navbar-center'>
                      <div className={classes.logo}>
                        <RouterLink to="/">
                          <Box sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'none' } }}>
                            <span>
                              <img src={ropay} alt="logo" />
                            </span>
                          </Box>
                        </RouterLink>
                      </div>

                      <Box className="nav-menu" ml={4} sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' } }}>
                        <Navbar />
                      </Box>
                      
                      {isDivVisible && (
                        (location === '/home' || location === '/') ? (
                          <div className="profile-nav">
                            <Box sx={{ display: { xs: 'block', sm: 'block', md: 'block', lg: 'block' } }}>
                              <h2 className={currentLanguage?.left_to_right === 0 ? 'main-restu-text-menu main-restu-text-menu-rtl' : 'main-restu-text-menu'}>
                                {t(restaurant?.title)}
                              </h2>
                            </Box>
                            <Badge badgeContent={Number(itemQuantity)} color="primary" className="cart-res" overlap="rectangular"> 
                              <img className='cart-size' src={cartIcon} onClick={handleOpenCart} alt="Cart" />
                            </Badge>
                          </div>
                        ) : (
                          <Language />
                        )
                      )}
                    </div>
                  </div>
                </Toolbar>
              </Container>
            </AppBar>
          </>
        )}

        {/* Modals */}
        {openModal && (
          <LoginModal
            openModal={openModal}
            handleClose={handleClose}
            onLoginSuccess={handleLoginSuccess}
          />
        )}

        {openModalProfile && (
          <ProfileMenu
            openModalProfile={openModalProfile}
            setOpenModalProfile={setOpenModalProfile}
            handleCloseProfile={handleCloseProfile}
            handleLogout={handleLogout}
          />
        )}
        {openModalCart && isMobile &&
          (
            <AddCart
              openModalCart={openModalCart}
              setOpenModalCart={setOpenModalCart}
              setPaymentSuccess={setPaymentSuccess}
              setPaymentData={setPaymentData}
              totalPrice={totalPrice}
              setTotalPrice={setTotalPrice}
              totalQuantity={totalQuantity}
              setTotalQuantity={setTotalQuantity}
            />
          )
        }
      </div>
    </div>
  );
}

const mapStateToProps = ({ authReducer, homeReducer, restaurantReducer, languageReducer }) => {
  const { loggedInSuccess } = authReducer;
  const { restaurantSuccess, updateOrderItemSuccess } = restaurantReducer;
  const { currentLanguage } = languageReducer;
  const { cartItemsList } = homeReducer;
  return { loggedInSuccess, restaurantSuccess, updateOrderItemSuccess, currentLanguage, cartItemsList };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCartItems: (data) => dispatch(actions.getCartItemsStart(data)),
    updateOrderItem: (data) => dispatch(actions.updateOrderItemStart(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



